/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartnerMobile
 */
export interface PartnerMobile {
    /**
     * 
     * @type {boolean}
     * @memberof PartnerMobile
     */
    primary?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PartnerMobile
     */
    mobileNumber?: string;
}

/**
 * Check if a given object implements the PartnerMobile interface.
 */
export function instanceOfPartnerMobile(value: object): value is PartnerMobile {
    return true;
}

export function PartnerMobileFromJSON(json: any): PartnerMobile {
    return PartnerMobileFromJSONTyped(json, false);
}

export function PartnerMobileFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerMobile {
    if (json == null) {
        return json;
    }
    return {
        
        'primary': json['primary'] == null ? undefined : json['primary'],
        'mobileNumber': json['mobileNumber'] == null ? undefined : json['mobileNumber'],
    };
}

export function PartnerMobileToJSON(json: any): PartnerMobile {
    return PartnerMobileToJSONTyped(json, false);
}

export function PartnerMobileToJSONTyped(value?: PartnerMobile | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'primary': value['primary'],
        'mobileNumber': value['mobileNumber'],
    };
}

